class WpPixel extends Pixel
{
  onPageView(type, id)
  {
    wph('track', 'ViewContent', {
      content_name: 'View'
    });
  }

  onCollectionPageView (collection, products)
  {
    const items = [];

    products.forEach(product => {
      items.push({
        id: product.id,
        name: product.title,
        category: product.product_type,
        price: parseFloat(product.variants[0].price).toFixed(2),
        in_stock: product.available
      });
    });

    wph('track', 'ViewContent', {
      content_name: 'ProductList',
      contents: items
    });
  }

  onFilterResult (collection, products)
  {
    const items = [];

    products.forEach(product => {
      items.push({
        id: product.id,
        name: product.title,
        category: product.product_type,
        price: parseFloat(product.variants[0].price).toFixed(2),
        in_stock: product.available
      });
    });

    wph('track', 'ViewContent', {
      content_name: 'ProductList',
      contents: items
    });
  }

  onProductPageView (product, variant)
  {
    wph('track', 'ViewContent', {
      content_name: 'ViewProduct',
      contents: [{
        id: product.id,
        name: product.title,
        price: (product.price / 100).toFixed(2),
        category: product.type,
        quantity: 1,
        in_stock: product.available
      }]
    });
  }

  onCartAdd (product)
  {
    wph('track', 'AddToCart', {
      contents: [{
        id: product.product_id,
        name: product.product_title,
        price: (product.price / 100).toFixed(2),
        category: product.product_type,
        quantity: product.quantity,
        in_stock: product.available
      }]
    });
  }
}
